import { formatAmericaPhoneToNumber, formateAmericaPhone } from '@/utils/phoneformat';
import { useEffect, useState } from 'react';
import MaterialTextInput, { MaterialTextInputProps } from '@/components/common/MaterialTextInput';

type PhoneTextInputProps = {
  /**value 从formItem获取的，用于展示的value。formItem包装后的input的value被formitem控制.（PhoneTextInput的value不展示） */
  value?: string;
  /**onChange 也是从formitem获取的 ，用来更新formitem的value的内置函数 */
  onChange?: (val?) => void;
} & MaterialTextInputProps;

const PhoneTextInput = ({ value, onChange, onBlur, ...rest }: PhoneTextInputProps) => {
  const [val, setVal] = useState(value);
  const onValueChange = input => {
    const usaNumber = formatAmericaPhoneToNumber(input);
    onChange(usaNumber); //更新formitem上的value，格式化为接口格式 1234567890
  };

  useEffect(() => {
    setVal(formateAmericaPhone(value)); //展示的格式(123) 456-7890
  }, [value]); //formitem通过onchange更新了value为接口格式，触发setVal
  return <MaterialTextInput {...rest} onChange={onValueChange} value={val} />;
};

export default PhoneTextInput;
